if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold, 10);
      if (!this.threshold) return;
      this.unsubscribeCart = null;
    }

    handleUpdate = (evt) => {
      const total = evt.cartData?.total_price ?? evt.total_price;
      if (typeof total !== 'undefined') this.render(total);
    };

    connectedCallback() {
      if (!this.threshold) return;

      this.progressBar = this.querySelector('[data-progress-bar]');
      this.track = this.querySelector('[role="progressbar"]');

      const initialTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      this.render(initialTotal);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleUpdate);
       }
    }

    disconnectedCallback() {
      if (typeof this.unsubscribeCart === 'function') {
        this.unsubscribeCart();
        this.unsubscribeCart = null;
      }
    }

    render(total) {
      const progress = Math.min(100, (total / this.threshold) * 100);

      if (this.progressBar) this.progressBar.style.width = `${progress}%`;

      if (this.track) this.track.setAttribute('aria-valuenow', Math.round(progress));
    }
  });
}